import { render, staticRenderFns } from "./SocialShareButton.vue?vue&type=template&id=352b5f60&scoped=true"
import script from "./SocialShareButton.vue?vue&type=script&lang=js"
export * from "./SocialShareButton.vue?vue&type=script&lang=js"
import style0 from "./SocialShareButton.vue?vue&type=style&index=0&id=352b5f60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352b5f60",
  null
  
)

export default component.exports